import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";

const Query = ({ data, loading, handleStatusManufacturer }) => {

  //host

  const columns = [
    {
      field: "name",
      headerName: "Name",
    },
    {
      field: "email",
      headerName: "Email",
    },

    {
      field: "mobile",
      headerName: "Mobile",
    },
    {
      field: "pin",
      headerName: "Pin",
    },
    {
      field: "query",
      headerName: "query",
    },

    // {
    //   field: "action",
    //   headerName: "Action",
    //   valueGetter: (v, d) => {
    //     const manufacturer = {
    //       pathname: "/view/details",
    //       manufacturerDetailsId: { id: d.manufacturer_id, name: d.name },
    //     };
    //     return (
    //       <>
    //         {
    //           <>
    //             <Link style={{ textDecoration: "none" }} href={manufacturer}>
    //               <VisibilityOutlinedIcon
    //                 sx={{
    //                   opacity: "0.8",
    //                   width: "40%",
    //                   marginTop: "3px",
    //                   marginBottom: "-10px",
    //                 }}
    //               />
    //             </Link>
    //           </>
    //         }

    //         {
    //           <Switch
    //             checked={d.status === 1 ? true : false}
    //             onClick={() =>
    //               handleStatusManufacturer(d.manufacturer_id, d.status)
    //             }
    //           />
    //         }
    //       </>
    //     );
    //   },
    // },
  ];

  return (
    <CTable
      columns={columns}
      data={data}
    //   isLoading={loading?.isLoading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(Query);

